var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(!!_vm.maxHeight ? 'max-height: 300px; overflow-y: auto;' : ''),domProps:{"innerHTML":_vm._s(_vm.question.description)}})}
var staticRenderFns = []

export { render, staticRenderFns }